import styled, { css } from 'styled-components';
import theme from 'styled-theming';

import * as Colors from '../../attrs/colors';

const ContainerType = theme('type', {
  tier_1: css`
    background: ${Colors.TIER_1};
    color: ${Colors.GREY};
  `,
  tier_2: css`
    background: ${Colors.TIER_2};
    color: ${Colors.WHITE};
  `,
  tier_3: css`
    background: ${Colors.TIER_3};
    color: ${Colors.WHITE};
  `,
});

const ContainerDot = theme('dot', {
  true: css`
    text-indent: -100%;
    border-radius: 4px;
    line-height: 1;
    width: 8px;
    height: 8px;
    padding: 0;
    font-size: 0;
  `,
});

export const Container = styled.span`
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  line-height: 20px;
  font-size: 0.8rem;
  overflow: hidden;
  border-radius: 2px;
  text-align: center;
  padding: 0 0.25rem;
  white-space: nowrap;
  text-transform: capitalize;

  ${ContainerType};
  ${ContainerDot};
`;
